import api from '../services/api';
import authService from './authService';

const getExpenses = async () => {
  const token = authService.getToken();
  try {
    const response = await api.get('/expenses', {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    console.log('Expenses API response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching expenses:', error);
    throw error;
  }
};

const getExpense = async (id) => {
  const token = authService.getToken();
  try {
    const response = await api.get(`/expenses/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching expense ${id}:`, error);
    throw error;
  }
};

const addExpense = async (expenseData) => {
  const token = authService.getToken();
  try {
    const response = await api.post('/expenses', expenseData, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error adding expense:', error);
    throw error;
  }
};

const updateExpense = async (id, expenseData) => {
  const token = authService.getToken();
  try {
    const response = await api.put(`/expenses/${id}`, expenseData, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error(`Error updating expense ${id}:`, error);
    throw error;
  }
};

const deleteExpense = async (id) => {
  const token = authService.getToken();
  try {
    const response = await api.delete(`/expenses/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error(`Error deleting expense ${id}:`, error);
    throw error;
  }
};

const getExpenseStats = async () => {
  const token = authService.getToken();
  try {
    const response = await api.get('/expenses/stats', {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    console.log('Expense stats API response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching expense stats:', error);
    throw error;
  }
};

const expenseService = {
  getExpenses,
  getExpense,
  addExpense,
  updateExpense,
  deleteExpense,
  getExpenseStats
};

export default expenseService;
